module.exports = __webpack_public_path__ + "img/sms.eac449bc.svg";